import React from "react";
import MuiDialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/styles";
import "./RefundResultDialog.css";

const Dialog = withStyles({
  paper: {
    maxWidth: 560,
    minWidth: 360,
    borderRadius: 14,
  },
})(MuiDialog);

// Shows the refund outcome as two copyable messages:
//  - Customer: safe to send to the refund requester (no internal ids)
//  - Internal: full detail (Kullanıcı ID / Kredi ID) for the team channel
export default function RefundResultDialog({
  open,
  success,
  customerMessage,
  internalMessage,
  onCopyCustomer,
  onCopyInternal,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="refund-result">
        <div className={`refund-result-status ${success ? "is-success" : "is-error"}`}>
          <span className="refund-result-dot" />
          {success ? "İade Başarılı" : "İade Başarısız"}
        </div>

        <div className="refund-result-block">
          <div className="refund-result-block-header">
            <span className="refund-result-block-title">Müşteri Mesajı</span>
            <button
              type="button"
              className="credit-btn credit-btn-primary"
              onClick={onCopyCustomer}
            >
              Müşteri Mesajını Kopyala
            </button>
          </div>
          <p className="refund-result-hint">
            Müşteriye iletilecek mesaj (Kullanıcı ID ve Kredi ID içermez).
          </p>
          <textarea
            className="refund-result-textarea"
            readOnly
            value={customerMessage}
            onFocus={(e) => e.target.select()}
          />
        </div>

        <div className="refund-result-block">
          <div className="refund-result-block-header">
            <span className="refund-result-block-title">İç Ekip Mesajı</span>
            <button
              type="button"
              className="credit-btn credit-btn-secondary"
              onClick={onCopyInternal}
            >
              İç Ekip Mesajını Kopyala
            </button>
          </div>
          <p className="refund-result-hint">
            Ekip kanalına iletilecek tam detaylı mesaj.
          </p>
          <textarea
            className="refund-result-textarea"
            readOnly
            value={internalMessage}
            onFocus={(e) => e.target.select()}
          />
        </div>

        <div className="refund-result-actions">
          <button
            type="button"
            className="credit-btn credit-btn-secondary"
            onClick={onClose}
          >
            Kapat
          </button>
        </div>
      </div>
    </Dialog>
  );
}
